<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <show-type1 v-if="showType === 1" :rowItem="rowItem" />
      <show-type2 v-if="showType === 2" :rowItem="rowItem" />
      <show-type3 v-if="showType === 3" :rowItem="rowItem" />
      <show-type4 v-if="showType === 4" :rowItem="rowItem" />
      <show-type5 v-if="showType === 5" :rowItem="rowItem" />
      <show-type6 v-if="showType === 6" :rowItem="rowItem" />
      <show-type20 v-if="showType === 20" :rowItem="rowItem" />
      <show-type21 v-if="showType === 21" :rowItem="rowItem" />
      <show-type22 v-if="showType === 22" :rowItem="rowItem" />
      <show-type23 v-if="showType === 23" :rowItem="rowItem" />
      <show-type30 v-if="showType === 30" :rowItem="rowItem" />
      <show-type45 v-if="showType === 45" :rowItem="rowItem" />
      <show-type55 v-if="showType === 55" :rowItem="rowItem" />
      <show-type60 v-if="showType === 60" :rowItem="rowItem" />
      <show-type70 v-if="showType === 70" :rowItem="rowItem" />
      <show-type80 v-if="showType === 80" :rowItem="rowItem" />
      <show-type81 v-if="showType === 81" :rowItem="rowItem" />
      <show-type82 v-if="showType === 82" :rowItem="rowItem" />
      <show-type83 v-if="showType === 83" :rowItem="rowItem" />
      <show-type84 v-if="showType === 84" :rowItem="rowItem" />
      <show-type85 v-if="showType === 85" :rowItem="rowItem" />
      <show-type90 v-if="showType === 90" :rowItem="rowItem" />
      <show-type100 v-if="showType === 100" :rowItem="rowItem" />
      <show-type110 v-if="showType === 110" :rowItem="rowItem" />
      <show-type120 v-if="showType === 120" :rowItem="rowItem" />
      <show-type121 v-if="showType === 121" :rowItem="rowItem" />
      <show-type122 v-if="showType === 122" :rowItem="rowItem" />
      <show-type123 v-if="showType === 123" :rowItem="rowItem" />
      <show-type130 v-if="showType === 130" :rowItem="rowItem" />
      <show-type131 v-if="showType === 131" :rowItem="rowItem" />
      <show-type101 v-if="showType === 101" :rowItem="rowItem" />
      <!-- REQ-2026-234328 3.4 售后单变更日志 -->
      <show-type91 v-if="showType === 91" :rowItem="rowItem" />
    </el-card>
  </div>
</template>

<script>
import showType1 from './type1.vue'
import showType2 from './type2.vue'
import showType3 from './type3.vue'
import showType4 from './type4.vue'
import showType5 from './type5.vue'
import showType6 from './type6.vue'
import showType20 from './type20.vue'
import showType21 from './type21.vue'
import showType22 from './type22.vue'
import showType23 from './type23.vue'
import showType30 from './type30.vue'
import showType45 from './type45.vue'
import showType55 from './type55.vue'
import showType60 from './type60.vue'
import showType70 from './type70.vue'
import showType80 from './type80.vue'
import showType81 from './type81.vue'
import showType82 from './type82.vue'
import showType83 from './type83.vue'
import showType84 from './type84.vue'
import showType85 from './type85.vue'
import showType90 from './type90.vue'
import showType100 from './type100.vue'
import showType110 from './type110.vue'
import showType120 from './type120.vue' 
import showType121 from './type121.vue' 
import showType122 from './type122.vue' 
import showType123 from './type123.vue' 
import showType130 from './type130.vue'
import showType131 from './type131.vue'
import showType101 from './type101.vue'
import showType91 from './type91.vue'
export default {
  props: ['rowItem'],
  components: {
    showType1, showType2, showType3, showType4, showType5, showType6, showType20, showType21, showType22, showType23,
    showType30, showType45, showType55, showType60, showType70, showType80, showType81, showType82, showType83, showType84, showType85,
    showType90, showType91, showType100, showType110, showType120, showType121, showType122, showType123, showType130, showType131, showType101
  },
  data() {
    return {
      showType: 0,
    }
  },
  created() {
    this.showType = this.rowItem.type
    console.log('this.showType', this.showType)
  },
  methods: {
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>

<style>
</style>
